import { render, staticRenderFns } from "./directories.vue?vue&type=template&id=5809cb54&scoped=true"
import script from "./directories.vue?vue&type=script&lang=js"
export * from "./directories.vue?vue&type=script&lang=js"
import style0 from "./directories.vue?vue&type=style&index=0&id=5809cb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5809cb54",
  null
  
)

export default component.exports